<template>
  <div>
    <home></home>
    <div class="pagerc">
        <div class="headerimg">
            <img class="pcshow" src="../assets/images/rc.jpg" alt="">
            <img class="mshow" src="../assets/images/mrc.png" alt="">
            <div class="title">
              <div class="titlep">
                <h3>大会日程</h3>
                <h4>MEETING AGENDA</h4>
              </div>
            </div>
        </div>
        <div class="inchild clear">
            <div class="wrapleft">
              <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane label="11月12日" name="first">
                  <div class="media">
                      <h2>评鉴中心精要</h2>
                      <ul>
                        <li class="noimg">
                          <div class="nov12">
                            <p><b>分享内容：</b></p>
                            <div class="space">
                              <div>
                                  <p><b> · </b>人才评鉴中心是什么</p>
                                  <p><b> · </b>人才评鉴中心的基础与历史</p>
                                  <p><b> · </b>人才评鉴中心的设计与完成</p>
                                  <p><b> · </b>人才评鉴中心数据的整合与使用</p>
                              </div>
                              <div>
                                  <p><b> · </b>人才评鉴中心的未来</p>
                                  <p><b> · </b>人才评鉴中心报告反馈</p>
                                  <p><b> · </b>后续三天你不能错过的活动及内容</p>
                              </div>
                            </div>
                          </div>
                        </li>
                        <h3>英文上午场：09:00-12:30<br>（包含午餐）</h3>
                        <li>
                          <div class="media-object pcshow">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/BruceWatt.png" alt="">
                            </div>
                          </div>
                          <div class="media-body nov12">
                            <p><b>09:00-12:30</b></p>
                            <p><b>主讲嘉宾：</b>布鲁斯·华特 博士| DDI副总裁</p>
                            <p><b>讲师简介：</b>布鲁斯·华特博士于2000年加入DDI，他目前担任DDI全球副总裁，主要负责DDI欧洲、印度、澳大利亚的业务以及DDI认证运营和全球卓越中心的工作。他与这些地区和职能部门的领导团队合作，确保其运营的高质量实践以及可持续的盈利性增长。华特博士是一名领导力实践方面的专家，他为各类跨国和区域组织提供与业务相关的咨询，主要在领导力发展和继任管理领域确定需求并提出解决方案。</p>
                          </div>
                        </li>
                      </ul>
                      <h3>中文下午场：13:30-17:00</h3>
                      <ul>
                        <li>
                          <div class="media-object pcshow">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/Billy.png" alt="">
                            </div>
                          </div>
                          <div class="media-body nov12">
                            <p><b>13:30-17:00</b></p>
                            <p><b>主讲嘉宾：</b>孙逸彬| DDI大中华区测评高级产品经理</p>
                            <p><b>讲师简介：</b>孙逸彬先生现为DDI大中华区高级产品经理，负责管理DDI评鉴中心。在任职期间，他设计、实施并推广DDI客户评鉴中心，引进且本土化最新的评鉴技术，以更好地为中国的组织服务。孙先生还致力于DDI评鉴中心的质量管理和DDI执行评鉴员的发展。</p>
                          </div>
                        </li>
                      </ul>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="11月13日" name="second">
                  <div class="media">
                    <h2>11月13日上午</h2>
                    <h3>主会场演讲</h3>
                    <ul>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/lbx.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>09:00 - 09:20</b></p>
                          <p><b>开场致辞</b></p>
                          <p>陆碧霞， DDI华东区董事总经理</p>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/bill.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>9:20 – 10:00</b></p>
                          <p><span><b>演讲主题：</b></span><span>划时代的21世纪评鉴中心——省时省成本的有效能力评鉴与反馈方法</span></p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=1">威廉·白翰姆 博士， DDI联合创始人兼执行董事长</a></p>
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p>21世纪初，DDI引入了一种全新且经济高效的方法以识别领导人才、诊断领导力发展需求，并让被评估者开始高效且有效的领导力学习路径。自此，数十万人体验了DDI的21世纪评鉴中心。演讲将详尽介绍21世纪评鉴中心的运作方式：
                              <br><b>· </b>测评行为定义的能力的各种新方法。
                              <br><b>· </b>测评构成能力的行为是可能的。
                              <br><b>· </b>测评师的判断可以更加可靠。</p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/sharif.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>10:00 – 10:40</b></p>
                          <p><b>演讲主题：</b>变革中重启微软灵魂的人才战略与实践</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=3">夏可涵， 微软亚洲区人力资源总经理</a></p>
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p>过去几年中，微软在CEO 萨提亚·纳德拉的领军下，转型有成，重回巅峰。微软的人力资源部门也在不断进行改变，在这场变革中首当其冲的是企业文化：
                              <br><b>· </b>我们为什么要选择发展。
                              <br><b>· </b>我们的文化。
                              <br><b>· </b>我们的文化转型模式。
                              <br><b>· </b>测量文化现状。
                            </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/gjd.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>10:40 – 11:20</b></p>
                          <p><b>演讲主题：</b>数字工业时代的组织能力和领导力发展</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=10">顾建党， 菲尼克斯电气集团执委会委员，菲尼克斯（中国）投资有限公司总裁</a></p>
                          <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>数字化时代，企业的战略逻辑、组织能力和领导力该做出哪些改变？菲尼克斯，一个来自德国的家族企业，选择“从未来看现在”，以客户价值为驱动改变组织形态，激活组织，激励个人；连接靠谱的人和事，建立协同、开放、共生共赢的生态系统，持续蜕变成长。
                              <br><b>· </b>未来组织转型的关键。
                              <br><b>· </b>数字工业时代的领导力和企业家精神。
                              <br><b>· </b>共同打造共创共享共生的生态系统，引领数字化工业新未来。
                              </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/lzm.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>11:20 – 12:00</b></p>
                          <p><b>演讲主题：</b>华人人才评鉴与发展：回顾与前瞻</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=13">刘兆明 博士， 辅仁大学心理学系教授</a></p>
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p>本主旨演讲之目的在于协助参会者了解华人人才评鉴与发展的历史脉络、实践经验与未来方向。演讲者将在学术与实践的脉络基础上说明大会邀请演讲之意涵与架构：
                            <br><b>· </b>华人人才评鉴与发展重要纪事之回顾。
                            <br><b>· </b>评鉴中心与领导力发展在华人社会之现况。
                            <br><b>· </b>未来发展之前瞻。
                            </p>
                          </span>
                        </div>
                      </li>
                    </ul>
                    <h2>11月13日下午</h2>
                    <h3>分会场A-CHO100专场分会场</h3>
                    <h6>人才评鉴与人才发展在中国领军企业的应用与实践</h6>
                    <ul>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/sy.png" alt="">
                          </div>
                        </div> 
                        <div class="media-body">
                          <p><b>13:30-13:35</b></p> 
                            <p><b>开场嘉宾及主持人</b></p> 
                            <p><a href="https://assessmentcenters.hrflag.com/brief?detail=43">沈雁，霍尼韦尔（中国）有限公司人力资源总监</a></p> 
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/xuf.png" alt="">
                          </div>
                        </div> 
                        <div class="media-body">
                          <p><b>13:35-14:15</b></p> 
                          <p><b>演讲主题：</b>鹰之翱翔 - TCL高管后备培养项目实践分享</p> 
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=11">许芳， CHO100联席理事长，TCL大学执行校长</a></p> 
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p>鹰系人才培养体系是TCL人才培养的一大亮点，鹰也已成为TCL挑战自我、不断变革，勇于蜕变精神的象征和图腾，与TCL的战略文化变革息息相关。
                            <br><b>· </b>鹰之缘起：在国际化困顿中绝地重生。
                            <br><b>· </b>鹰之选拔：选对人是培养人的第一步。
                            <br><b>· </b>鹰之历练：针对更大的责任，从实、从难、从严训练是未来胜任的保证。
                            <br><b>· </b>鹰之翱翔：任用培养的人是最有效的培养。
                            </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div><img src="http://static.hrflag.com/img/speakers/ddi/wj.png" alt=""></div>
                        </div> 
                        <div class="media-body">
                          <p><b>14:15-14:55</b></p> 
                          <p><b>演讲主题：</b>人才评鉴助力提升领导力优势</p> 
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=46">吴静， 液化空气人力资源副总裁</a></p> 
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p><b>· </b>人才评鉴的重要性及其意义，聚焦于其普适性、相对客观性和跨界性。
                            <br><b>· </b>液化空气如何运用人才评鉴助力人才管理和领导力发展，中间的成果和问题。
                            <br><b>· </b>面向未来，对人才评鉴的畅想和人才评鉴行业的期望。
                            </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div><img src="http://static.hrflag.com/img/speakers/ddi/cmfrank.png" alt=""></div>
                        </div> 
                        <div class="media-body">
                          <p><b>14:55-15:35</b></p> 
                          <p><b>演讲主题：</b>团队氛围激活组织战力</p> 
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=33">陈敏 博士， 蒂森克虏伯电梯中国首席人力资源官</a></p> 
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p>好的领导能创造好的组织氛围，而好的人才需要好的氛围才能产生好的结果。用愿景驱动人才，人才驱动战略，有盟约的团队才能长久致胜。
                            <br><b>· </b>以团队氛围为主导的领导力发展模式。
                            <br><b>· </b>以终为始的领导力发展举措。
                            </p>
                          </span>
                        </div>
                      </li> 
                      <li>
                          <div class="media-object">
                            <div><img src="http://static.hrflag.com/img/speakers/ddi/wm.png" alt=""></div>
                          </div> 
                          <div class="media-body">
                            <p><b>15:55-16:35</b></p> 
                            <p><b>演讲主题：</b>业务驱动的人才画像构建与人才评鉴发展实践</p> 
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=45">魏梅 博士， 浙江吉利控股集团副总裁</a></p> 
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>在时代变革以及吉利从传统车企向全球创新型企业战略转型的背景下，吉利人力资源聚焦人才战略、人才赋能和人才体验，重构人才经营模式。吉利人才画像的构建提供了人才经营战略实现的基础，将助力人才精准识别和精准发展。
                              <br><b>· </b>介绍业务驱动背景下的人才画像构建。
                              <br><b>· </b>介绍吉利人才评鉴状况。
                              <br><b>· </b>分享吉利人才评鉴实践案例。
                              </p>
                            </span>
                          </div>
                        </li> 
                      <li class="noimg">
                        <div class="media-object">
                          <div>
                            <img src="" alt="">
                          </div>
                        </div> 
                        <div class="media-body">
                            <p><b>16:35-17:50</b></p> 
                            <p><b>【圆桌对话】人才评鉴与人才发展在中国领军企业的应用与实践</b></p> 
                            <div class="imgs">
                              <img src="http://static.hrflag.com/img/speakers/ddi/sy.png" alt="">
                              <img src="http://static.hrflag.com/img/speakers/ddi/gmf.png" alt="">
                              <img src="http://static.hrflag.com/img/speakers/ddi/nz.png" alt="">
                              <img src="http://static.hrflag.com/img/speakers/ddi/zjd.png" alt="">
                              <img src="http://static.hrflag.com/img/speakers/ddi/xuf.png" alt="">
                              <img src="http://static.hrflag.com/img/speakers/ddi/wj.png" alt="">
                              <img src="http://static.hrflag.com/img/speakers/ddi/cmfrank.png" alt="">
                              <img src="http://static.hrflag.com/img/speakers/ddi/wm.png" alt="">
                            </div>
                            <p><b>主持人：</b>沈　雁， 霍尼韦尔（中国）有限公司人力资源总监</p> 
                            <p><b>嘉　宾：</b>郭美峰， 菲尼克斯（中国）投资有限公司人力资源总监</p> 
                            <div>
                              <p>倪　铮， 陶氏中国人力资源总监</p> 
                              <p>赵继德， 华化学集团人力资源高级总监、万华大学执行校长</p>
                              <p>许　芳， CHO100联席理事长、TCL大学执行校长</p> 
                              <p>吴　静， 液化空气（中国）投资有限公司中国区人力资源副总裁</p> 
                              <p>陈　敏， 博士， 蒂森克虏伯电梯中国首席人力资源官</p>
                              <p>魏　梅， 博士， 浙江吉利控股集团副总裁</p>
                            </div>
                          </div>
                        </li> 
                      </ul>
                    <h3>分会场B-政府专场分论坛</h3>
                    <h6>政府机构最佳人才评鉴实践</h6>
                    <ul>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/bill.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>13:30 - 13:40</b></p>
                          <p><b>开场嘉宾及主持人</b></p>
                          <p><a href="https://assessmentcenters.hrflag.com/brief?detail=53">威廉·白翰姆 博士， DDI联合创始人兼执行董事长</a></p>
                        </div>
                      </li>
                      <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/Svetlana.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>13:40 - 14:20</b></p>
                            <p><b>演讲主题：</b>索契市奥运评鉴技术的应用与影响</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=95">Svetlana Simonenko 博士，俄罗斯 Detech Group管理合伙人</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>因举办大型国际活动经验有限，且缺乏志愿者文化，2014年索契奥运会和残奥会面临着巨大挑战。彼时索契奥运的目标是吸引、选拔、培训、调动由70,000人组成的来自俄罗斯各地的多样化团队。这也是为什么组委会选择了“5个对”的方法：对的人、对的时间、对的技能、对的工作、对的态度。</p>
                            </span>
                          </div>
                        </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/Clara Chua.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>14:30 - 15:10</b></p>
                          <p><b>演讲主题：</b>探索评鉴中心未来领导者的人格画像</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=91">Clara Yi Xin Chua， 新加坡国防部心理学家</a></p>
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p>新加坡军方挑选未来领导人的方法之一是通过评鉴中心——情景测试（SITEST）评估新兵是否适合成为军官。SITEST旨在通过让新兵进行逼真的模拟来评估他们的领导潜力。
                            <br><b>· </b>探索通过评鉴中心选出的未来领导者的个性画像。
                            <br><b>· </b>从系统角度审视组织中领导者多样性较低的短期和长期影响。
                            <br><b>· </b>讨论组织可以采取哪些措施来提升多样性。
                            </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/gxd.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>15:20 - 16:00</b></p>
                          <p><b>演讲主题：</b>领导人才测评实践探索与反思</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=94">谷向东 博士， 北京领导人才考核评价服务中心研究员、研发负责人</a></p>
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p><b>· </b>回顾领导干部竞争性选拔的发展历程，分析干部测评实践中的问题和挑战。
                            <br><b>· </b>简介二十多年领导干部测评技术研发历程，重点阐述《领导人才测评系统》的构建、修订及应用情况。
                            <br><b>· </b>反思干部测评实践，展望未来，明确方向。
                            </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/sihui.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>16:10 - 16:50</b></p>
                          <p><b>演讲主题：</b>新加坡警察局的评鉴应用</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=97">Si Hui Ko， 新加坡警察局首席心理学家</a></p>
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p>鉴于现代警务行动的复杂性，在新加坡警察局（SPF），让一名不合适的警官担任关键领导职务所产生成本会带来严重后果。对SPF有效运作至关重要的关键领导职位之一是中层职位。为确保合适的人担任这一职务，新加坡警察局建立了评鉴中心，并根据SPF领导能力框架对官员进行测评。此次分享的重点是ACCO作为评鉴资源支持SPF管理层决策的用途及其价值。</p>
                          </span>
                        </div>
                      </li>
                    </ul>
                    <h3>分会场C</h3>
                    <ul>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/zy.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>13:30 - 13:40</b></p>
                          <p><b>开场嘉宾及主持人</b></p>
                          <p><a href="https://assessmentcenters.hrflag.com/brief?detail=50">赵亚，瑞典奥托立夫中国区人力资源副总裁</a></p>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/pqy.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>13:40 - 14:20</b></p>
                          <p><b>演讲主题：</b>将领导者与挑战匹配的力量</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=77">彭泉勇， SHL中国区首席顾问</a></p>
                         <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p>为深入了解如何最好地解决动荡不定的工作环境和静态领导战略之间的脱节，SHL开展了25年来规模最大、最全面的领导力研究。该研究收集了领导者的在职绩效信息，并深入探究各类领导岗位之间的差异。同时收集了从团队动态、组织文化到行业状况等60多类工作环境信息。
                            <br><b>· </b>SHL在领导力测评创新的前沿洞察及理念。
                            <br><b>· </b>方法论。
                            <br><b>· </b>案例分享。
                            </p>
                         </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/zy.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>14:30 - 15:10</b></p>
                          <p><b>演讲主题：</b>创新小组DNA识别与创新敏捷小组运作实践</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=50">赵亚，瑞典奥托立夫中国区人力资源副总裁</a></p>
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p>数字时代未来企业竞争最终是效率之争。如何让一家原本就具备一套完善体系的跨国公司突破传统去创新并与时俱进地轻盈敏捷起来，打造创新DNA，赋予新的活力变得尤为重要。
                            <br><b>· </b>创新DNA人才画像。
                            <br><b>· </b>创新小组DNA识别要点与挑战。
                            <br><b>· </b>敏捷组织的小范围成功——创新敏捷小组运作实践。
                            </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/jiq.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>15:20 - 16:00</b></p>
                          <p><b>演讲主题：</b>赋能+：建立行业人才标准 共赢生态圈</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=38">季菁， 惠氏营养品商学院执行院长</a></p>
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p><b>· </b>母婴行业店长能力发展白皮书调研分享。
                            <br><b>· </b>基于人才评鉴研究洞察的人才发展的解决方案。
                            <br><b>· </b>人才评鉴借人才发展的最佳实践。
                            </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/xf.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>16:10 - 16:50</b></p>
                          <p><b>演讲主题：</b>企业打通人才供应链的十项修炼</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=87">许锋 博士， 倍智测聘网络科技股份有限公司创始人、CEO</a></p>
                         <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p><b>· </b>打造人才供应链的目标是实现组织可持续的高绩效均衡。
                            <br><b>· </b>人员冗余的风险指数级高于人员不足的风险。
                            <br><b>· </b>能力分解、盘点和组合是打造人才供应链的核心。
                            <br><b>· </b>选比育更重要。
                            </p>
                         </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/gxl.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>17:00 - 17:40</b></p>
                          <p><b>演讲主题：</b>将沙盘模拟培训应用于AC的案例研究</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=61">高喜乐， 尚贤进邦咨询（北京）有限公司研发总监</a></p>
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p><b>· </b>将商业模拟培训计划与评鉴中心相结合考核高管的案例分享。
                            <br><b>· </b>高管能力分类方面，商业模拟培训计划中的行为观察的效度和效能。
                            <br><b>· </b>在高管评鉴设计及应用中采用商业模拟培训项目的原因。
                            </p>
                          </span>
                        </div>
                      </li>
                    </ul>
                    <h3>分会场D</h3>
                    <ul>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/zyc.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>13:30 - 13:40</b></p>
                          <p><b>开场嘉宾及主持人</b></p>
                          <p>朱彦昌， DDI华北区董事总经理</p>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/thonton.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>13:40 - 14:20</b></p>
                          <p><b>演讲主题：</b>怎么知道评鉴中心是否有效？混合理论、研究与实践的知识论</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=18">George C. Thornton III 博士， 美国科罗拉多州立大学终身教授</a></p>
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p>本演讲总结了评鉴中心方法理论、研究和实践的最佳信息来源，并提供了一个由实际影响和从我们倾向的认识论中衍生出的建议清单，即理论、研究和实践的融合。在讲者看来，设计和实施评鉴中心的最佳方法是将全面的流程理论、实证研究证据和在各类组织中评估的实际应用案例相结合。演讲最后亦简要说明了该模式如何应用于其他人力资源管理的干预措施。</p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/ygg.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>14:30 - 15:10</b></p>
                          <p><b>演讲主题：</b>评鉴中心和发展中心在中国的机会和挑战</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=30">闫巩固 博士， 北京师范大学心理学部副教授</a></p>
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p>本演讲将首先介绍中国评鉴中心的历史，其次将以案例说明评鉴中心和发展中心的主要用途，以及演讲者开发的两个新的模拟训练。最后，讲者将总结理论研究和实践的机遇与挑战。</p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/xxy.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>15:20 - 16:00</b></p>
                          <p><b>演讲主题：</b>元领导力：基于心理行为科学的体验式领导力测评与发展方法论</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=29">许晓勇 博士， 北京师范大学心理学部教授</a></p>
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p>近年来，众多商学院学员、创业者和企业管理者，带着提升个人、团队和组织领导力的希望，去到戈壁、沙漠、森林等极具挑战的环境，深度认知、体验和反思。NCCL将这种基于心理行为科学研究的深度体验式领导力测评与发展方法论称为“元领导力”。演讲者将在本次演讲中与大家分享NCCL和JLAD近三年的相关研究发现。</p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/zk.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>16:10 - 16:50</b></p>
                          <p><b>演讲主题：</b>基于魅力型人格的领导素质评价与领导力开发</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=31">章凯 博士， 中国人民大学商学院教授</a></p>
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p>本报告基于对人性的新理解和共同目标在领导力形成中的核心作用，从探索领导者的魅力型人格入手，重新思考和整合领导者的特质、行为、价值观、以及能力在领导力形成中的作用。
                            <br><b>· </b>领导魅力与魅力型人格。
                            <br><b>· </b>魅力型人格的结构与测量。
                            <br><b>· </b>基于魅力型人格的领导素质评价与领导力开发。
                            </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/lzh.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>17:00 - 17:40</b></p>
                          <p><b>演讲主题：</b>大学中的领导力发展：院校人才评鉴与发展的实践经验</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=22">李志鸿 博士， 亚洲大学心理学系副教授</a></p>
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p><b>· </b>综论大学对领导力教育的观点及其实务。
                            <br><b>· </b>略述亚洲大学创意领导中心的简史与现况。
                            <br><b>· </b>论述学院的领导力教育作为长远领导发展的基础性、核心性与发展性。  
                            </p>
                          </span>
                        </div>
                      </li>
                    </ul>
                    <h3>分会场E</h3>
                    <ul>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/wmr.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>13:30 - 13:40</b></p>
                          <p><b>开场嘉宾及主持人</b></p>
                          <p><a href="https://assessmentcenters.hrflag.com/brief?detail=86">魏美蓉， 韦莱韬悦台湾分公司人才与奖酬总经理</a></p>
                        </div>
                      </li>
                      <li class="noimg">
                        <div class="media-object">
                          <div>
                            <img src="" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>13:40 - 14:20</b></p>
                          <p><b>演讲主题：</b>数字化时代人才管理策略实战经验分享</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=86">魏美蓉， 韦莱韬悦台湾分公司人才与奖酬总经理</a></p>
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p>针对数字化时代的人才难题，韦莱韬悦进行了完整而深入的研究，并且提出“转型六个对”方案供企业运用。本演讲将分享数字化时代下组织创新的新思维，新世代领导人的关键能力和养成，以及数字化人才库的建设与实例分享。</p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/dxg.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>14:30 - 15:10</b></p>
                          <p><b>演讲主题：</b>拿到「体检报告」后你该做些什么——谈评鉴后人才发展的实践</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=60">董晓光， 芮可企管顾问股份有限公司总经理</a></p>
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p>通过评鉴中心获取那些数据与指标代表着什么意义？应该讲这些数据连接到后续的人才发展中？本演讲将介绍评鉴中心法的量尺与反馈，并探讨如何通过PAD工作坊协助受评者发展胜任力。</p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/lws.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>15:20 - 16:00</b></p>
                          <p><b>演讲主题：</b>领导发展行为转化与项目衡量</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=5">刘伟师， 伟师咨询总经理</a></p>
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p><b>· </b>传统领导发展实践三步骤与不好处理的问题。
                            <br><b>· </b>移动互联网下时代下行为发展落地：应用、反馈与反思。
                            <br><b>· </b>全项目衡量：参与度、满意度与知识获取之外……
                            <br><b>· </b>项目后与人岗匹配决策的串接。
                            </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/alex.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>16:10 - 16:50</b></p>
                          <p><b>演讲主题：</b>国际视野下的中国人才测评发展之路</p>
                          <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=83">唐兆辉， 全美在线副总裁</a></p>
                          <span class="flexspan">
                            <p><b>演讲介绍：</b></p>
                            <p>演讲者将讲述中国人才测评市场的迅速增长史及其技术应用，并剖析近20年来中国人才测评考试数据，探讨中国人才测评考试市场的智能化发展与未来趋势。</p>
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="11月14日" name="third">
                  <div class="media">
                      <h2>11月14日上午</h2>
                      <h3>分会场A</h3>
                      <ul>
                         <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/panx.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>09:00 - 09:10</b></p>
                            <p><b>开场嘉宾及主持人</b></p>
                            <p>潘湘， DDI中国区高级顾问</p>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/wul.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>09:10 - 09:50</b></p>
                            <p><b>演讲主题：</b>华星人才发展之路</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=52">吴岚， 华星光电人力资源高级副总裁、华星学院院长</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>经过不断的探索，华星光电打造了以人才评鉴为基础的企业内生性人才发展体系，致力于发掘并发展更有潜力的年轻人。
                              <br><b>· </b>基于业务发展的内生性人才发展框架。
                              <br><b>· </b>华星内部评鉴中心的搭建与实践。
                              <br><b>· </b>华星未来人才发展之路。
                              </p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/ario.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>10:00 - 10:40</b></p>
                            <p><b>演讲主题：</b>充分运用评鉴中心数据价值的方案</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=56">Ario Bimo， 印尼Daya Dimensi评鉴中心负责人</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>本演讲介绍了印尼Daya Dimensi成为数据驱动的评鉴中心的举措，即通过分析大量存档数据从而得出有意义的描述性信息及相关数据的含义。
                              <br><b>· </b>成为数据驱动的评鉴中心。
                              <br><b>· </b>将数据集转化为实用信息的案例分享。
                              <br><b>· </b>协同评鉴中心和发展中心。
                              </p>
                            </span>
                          </div>
                        </li>
                        <li class="twospeakers">
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/mangal.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>10:50 - 11:30</b></p>
                            <p><b>演讲主题：</b>超越评鉴中心：从发现到发展</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=72">Mangal Dhuri， 印度Cerebrus Consultants公司首席顾问</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>评鉴过程本身可以成为发展之旅的开始，以及演讲者创造此类学习体验的案例。
                              <br><b>· </b>演讲者通过对不同模型的实验，超越评鉴本身为客户创造有意义的发展之旅的案例。
                              <br><b>· </b>在实践中学习到的经验，以及在此过程中开发出的工具。
                              </p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/Mark Busine.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>11:40 - 12:20</b></p>
                            <p><b>演讲主题：</b>动态二重奏：人才评鉴与发展</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=73">马克·步西尼， DDI产品管理副总裁</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>结合DDI半世纪以来的经验、实践和研究，探讨评鉴中心与发展之间的历史关系。
                              <br><b>· </b>在当今商业及领导力环境中，将评鉴中心与发展结合的优势。
                              <br><b>· </b>关于如何最大限度地结合评鉴中心和发展的建议。
                              </p>
                            </span>
                          </div>
                        </li>
                      </ul>
                      <h3>分会场B</h3>
                      <ul>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/lhy.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>09:00 - 09:10</b></p>
                            <p><b>开场嘉宾及主持人</b></p>
                            <p><a href="https://assessmentcenters.hrflag.com/brief?detail=67">李慧渊， DDI 大中华区项目咨询总经理</a></p>
                          </div>
                        </li>
                        <li class="noimg">
                          <div class="media-object">
                            <div>
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>09:10 - 09:50</b></p>
                            <p><b>演讲主题：</b>20年大中华区高管领导力：回首与展望</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=67">李慧渊， DDI 大中华区项目咨询总经理</a></p>
                           <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>分析DDI 20年在大中华区的高管评鉴数据，得出核心趋势。
                              <br><b>· </b>比对大中华区高管领导力数据与全球高管数据，分析文化与经济发展对领导力的影响。
                              <br><b>· </b>展望中国领导者的未来画像。
                              </p>
                           </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/Vincent.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>10:00 - 10:40</b></p>
                            <p><b>演讲主题：</b>小趋势 大未来：数字化转型背景下的组织与人才</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=102">宋彬， 怡安翰威特顾问总监</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>在数字化时代，如何有效利用各类组织数据从而真正落地企业战略？如何吸引发掘培养未来的数字化人才? 都已经成为企业的当下关注的焦点。
                              <br><b>· </b>数字化背景下的组织数据应用场景及案例分享。
                              <br><b>· </b>构建企业内部数字化能力的关键步骤及数字化人才特质。
                              <br><b>· </b>数字化时代背景下的新生代人才吸引及评估。
                              </p>
                            </span>
                          </div>
                        </li>
                        <li class="twospeakers">
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/gum.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>10:50 - 11:30</b></p>
                            <p><b>演讲主题：</b>战略转型下的人资变革及数据力量</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=51">顾明， 云南白药集团健康大数据服务平台总经理</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>商业变革中互联网营销团队组建的得失。
                              <br><b>· </b>数据体系建设是HR部门必备基本功。
                              </p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/tym.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>11:40 - 12:20</b></p>
                            <p><b>演讲主题：</b>初创企业0-1阶段，数据在人才、文化、组织中的运用</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=62">田予苗， 肯耐珂萨中国区组织人才发展副总裁</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>初创企业的人才画像。
                              <br><b>· </b>初创企业中人才与文化的关联。
                              <br><b>· </b>初创企业中组织的数据特征。
                              </p>
                            </span>
                          </div>
                        </li>
                      </ul>
                      <h3>分会场C</h3>
                      <ul>
                         <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/dxx.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>09:00 - 09:10</b></p>
                            <p><b>开场嘉宾及主持人：</b></p>
                            <p>邓晓霞， DDI中国区高级顾问</p>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/zjd.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>09:10 - 09:50</b></p>
                            <p><b>演讲主题：</b>卓越人才的培养，从人才评鉴启始</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=49">赵继德， 万华化学集团人力资源高级总监、万华大学执行校长</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>本演讲将详述万华化学集团人力资源部为人才培养做出的全面战略性规划。在实施培养计划前，首先通过评鉴工具协助高层掌握领导团队的全貌，同时也帮助领导者提高自我认知，加深对自我发展的理解。并且，针对领导团队共性的发展点规划团队发展，也根据个人特点制定领导者的个人发展方案。</p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/Pieter Bronkhorst.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>10:00 - 10:40</b></p>
                            <p><b>演讲主题：</b>何为预测领导潜力的最佳方法？评鉴中心、认知测试或性格测试？关于该议题的最新研究</p>
                            <p><b>演讲嘉宾：</b></p>
                            <p><a href="https://assessmentcenters.hrflag.com/brief?detail=79">Pieter Bronkhorst 博士，南非 Evalex Talent Solutions 创始人</a></p>
                          </div>
                        </li>
                        <li class="twospeakers">
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/david.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>10:50 - 11:30</b></p>
                            <p><b>演讲主题：</b>到哪里灭火？美国消防队评鉴中心的应用</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=92">David Slivinski， 美国伊利诺伊州消防长官协会评鉴咨询服务项目总监</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>全世界每天有数十万人次依靠消防部门和救援部门提供灭火和救生的紧急医疗援助。本演讲将以美国消防队的人才评鉴实践为例，详解以下几点内容：
                              <br><b>· </b>美国消防队评鉴中心概述。
                              <br><b>· </b>支撑强悍应急领导力的绩效和行为维度。
                              <br><b>· </b>火场领导力决策情景模拟。
                              </p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/khd.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>11:40 - 12:20</b></p>
                            <p><b>演讲主题：</b>解锁人的力量——通过人才评鉴提高选用育留的管理水平和效率</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=63">康怀德， 克拉维斯咨询总经理</a></p>
                           <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>行为评估和认知评估的作用。
                              <br><b>· </b>科学客观地分析岗位要求与建模。
                              <br><b>· </b>商业目标、企业文化、招聘提拔和人员管理的有机结合，提高选用育留的效率。
                              </p>
                           </span>
                          </div>
                        </li>
                      </ul>
                      <h3>分会场D</h3>
                      <ul>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/lf.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>09:00 - 09:10</b></p>
                            <p><b>开场嘉宾及主持人</b></p>
                            <p><a href="https://assessmentcenters.hrflag.com/brief?detail=66">风里（李峰） 博士， 「领导力语法」理论模型创始人</a></p>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/朱伟正.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>09:10 - 09:50</b></p>
                            <p><b>演讲主题：</b>企业学习和人才发展趋势</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=98">朱伟正， 《培训》杂志主编</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>从培训、学习、绩效到业务结果，成为真正的业务合作伙伴。
                              <br><b>· </b>企业大学成为内外赋能高地。
                              <br><b>· </b>数字化时代的学习创新。
                              <br><b>· </b>领导力发展与高管培训仍然是学习发展领域的核心。
                              </p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/lf.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>10:00 - 10:40</b></p>
                            <p><b>演讲主题：</b>少一些维度，多一些效度：评估领导潜能的极简主义观点</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=7">风里（李峰） 博士， 「领导力语法」理论模型创始人</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>维度越少，效度越高，高潜质领导人才的DICE模型。 
                              <br><b>· </b>怎样最快最准地测评DICE?
                              <br><b>· </b>如果只有一个小时，AC 矩阵应该长啥样？
                              <br>- 一个单一题目的智商（g因素）测验
                              <br>- 即时计分行为访谈
                              <br>- 一个微型行为模拟演示
                              </p>
                            </span>
                          </div>
                        </li>
                        <li class="twospeakers">
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/黄一峰.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>10:50 - 11:30</b></p>
                            <p><b>演讲主题：</b>以人工智能系统建立人才评鉴机制：实验项目研究分享</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=21">黄一峰 博士， 淡江大学公共行政学系副教授</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>应用新技术提高人才评鉴的质量已变得越来越普遍，如何通过人工智能（AI）系统构建评鉴机制，也将成为一大新趋势。AI系统可以从较少的样本中学习评鉴标准，并在样本增加时逐步拓展评鉴的能力。本演讲旨在探索评鉴中心AI试点的应用过程，以及如何建立无需测评师的无领导小组讨论评鉴机制。</p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/CathyCao.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>11:40 - 12:10</b></p>
                            <p><b>演讲主题：</b>数字化人才与领导力</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=57">曹梅蓉， YSC中国区负责人兼管理顾问</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>数字化评鉴技术并非取代，而是帮助人类能够更好地应对不可预测的未来。人们可以将某些任务自动化完成，而其他诸如激励性领导力，则将更加以人为本。
                              <br><b>· </b>技术正在改变我们的生活。
                              <br><b>· </b>在机会的迷宫中前行。
                              <br><b>· </b>引领创造未来。
                              </p>
                            </span>
                          </div>
                        </li>
                      </ul>
                      <h3>分会场E</h3>
                      <ul>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/lkg.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>09:00 - 09:10</b></p>
                            <p><b>开场嘉宾及主持人：</b></p>
                            <p><a href="https://assessmentcenters.hrflag.com/brief?detail=69">梁开广 博士， 希典咨询董事总经理</a></p>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/alan.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>09:10 - 09:50</b></p>
                            <p><b>演讲主题：</b>运用性格任务提升评鉴中心效度</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=55">Alan Howard，英国 Quest Assessments总监</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>将性格评鉴作为评鉴中心的一部分。
                              <br><b>· </b>在评鉴能力时，性格是否相关？
                              <br><b>· </b>降低评鉴中心效度的常见因素以及性格评鉴如何提供帮助。
                              <br><b>· </b>性格测试的常见问题。
                              </p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/KristaPederson.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>10:00 - 10:40</b></p>
                            <p><b>演讲主题：</b>评测全球人才：用人格测评来选拔全球和亚太区的人才</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=65">贝爱灵， Hogan Assessment Systems亚太区业务发展总监</a></p>
                           <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>人格测评是选拔和发展人才的最佳方式之一，尤其是在全球文化及商业环境中准确性的应用实践。
                              <br><b>· </b>不同国家，尤其是亚洲各国，领导者和人才的个性各不相同。
                              <br><b>· </b>了解这些差异将有助于公司制定更公平、更准确的选拔和发展标准。
                              </p>
                           </span>
                          </div>
                        </li>
                        <li class="twospeakers">
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/lkg.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>10:50 - 11:30</b></p>
                            <p><b>演讲主题：</b>个性领导力的提升：中国企业的实践</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=69">梁开广 博士， 希典咨询董事总经理</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>简要回顾有关个性和领导有效性的研究，并分享若干个针对中国企业领导人的研究实例。
                              <br><b>· </b>领导力发展的基石源于自省自知，即对自己的正确洞察。领导者如能客观地了解自己的个性和工作风格的相对优缺点，可以激发他们采取措施提升领导行为的有效性。
                              <br><b>· </b>禀性难移，行为可塑。不是所有个性短板都需要改变，但对影响领导力发展甚至致命的弱点一定要加以管理和控制。
                              </p>
                            </span>
                          </div>
                        </li>
                        <li class="twospeakers">
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/wy.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>11:40 - 12:20</b></p>
                            <p><b>演讲主题：</b>跨越东西方：文化敏捷度及能力预测解决方案的发展</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=85">王洋， 科必思管理咨询高级顾问</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>为适应在中国的使用，对一个历史悠久且享有盛誉的性格问卷进行了成功改编。
                              <br><b>· </b>一个文化敏锐模型——个体通过洞见、影响和实施，在中国的业务环境中有效行事的总体潜力。
                              <br><b>· </b>以一个经充分验证的分层结构的胜任力框架为基础，为方便直线经理和测评者使用，建立基于胜任力的报告形式。
                              </p>
                            </span>
                          </div>
                        </li>
                      </ul>
                      <h2>11月14日下午</h2>
                      <h3>分会场A-DAC专场分论坛</h3>
                      <h6>领导力发展中心：行为评鉴及行为培训二重奏</h6>
                      <ul>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/thonton.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>13:30 - 13:45</b></p>
                            <p><b>开场嘉宾及主持人</b></p>
                            <p><a href="https://assessmentcenters.hrflag.com/brief?detail=18">George C. Thornton III博士，美国科罗拉多州立大学终身教授</a></p>
                          </div>
                        </li>
                        <li class="noimg">
                          <div class="media-object">
                            <div>
                              <img src="" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>13:45 - 14:15</b></p>
                            <p><b>演讲主题：</b>发展中心模型</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=18">George C. Thornton III博士，美国科罗拉多州立大学终身教授</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>发展中心的模型。
                              <br><b>· </b>该模型基本特征下的原则。
                              <br><b>· </b>该模型有效性的证据。
                              </p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/mash.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>14:15 - 15:00</b></p>
                            <p><b>演讲主题：</b>评鉴中心提供行为反馈38年经验回顾</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=75">Masahiro Tohyama，日本MSC总裁</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>1972年，MSC在日本开设了第一家评鉴中心，并从此成为日本专业从事人才评鉴的公司。MSC评鉴中心的一大特点是，在小组讨论式练习中，参与者被分组，组与组之间相互观察，并相互反馈。此外，MSC还致力于将评鉴与培训相结合，并且此举非常适合日本文化。</p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/naghi.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>15:10 - 15:35</b></p>
                            <p><b>演讲主题：</b>领导力发展评鉴中心：基于经验的测试</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=27">Naghi Radi Afsouran博士，伊朗圭兰大学教育科学系助理教授</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>本研究的目的是从实证上验证领导力发展评鉴中心 （LDAC） 的效能。研究采用了预测试、后测试的实验设计，结果表明LDAC的培训内容和设计在设计、效度和交付方面均有效。</p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/Sandra.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>15:35 - 16:10</b></p>
                            <p><b>演讲主题：</b>继任发展项目及其研究发现</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=81">Sandra Schlebusch，南非Lemasa公司创始人</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>是什么让教练发展中心独一无二。
                              <br><b>· </b>评鉴之后的活动对行为改变的重要性。
                              <br><b>· </b>在以人为导向的其他进程中适当嵌入发展评鉴中心的重要性。
                              </p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/martin.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>16:10 - 16:50</b></p>
                            <p><b>演讲主题：</b>长久屹立的人才发展中心-如何建立领导者的习惯</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=26">Martin Lanik博士，Pinsight公司CEO</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>数字化转型如何影响评鉴中心实践。
                              <br><b>· </b>将评鉴中心转战至线上的注意事项。
                              <br><b>· </b>利用技术帮助改变行为。
                              </p>
                            </span>
                          </div>
                        </li>
                      </ul>
                      <h3>分会场B</h3>
                      <ul>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/cjp.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>13:30 - 13:40</b></p>
                            <p><b>开场嘉宾及主持人：</b></p>
                            <p>曹洁平， DDI华东区咨询服务总监</p>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/bill.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>13:40 - 14:20</b></p>
                            <p><b>演讲主题：</b>探讨评鉴中心在性别、种族、年龄、宗教、国家及性别倾向上的可能偏见</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=53">威廉·白翰姆 博士， DDI联合创始人兼执行董事长</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>每当人类被要求做决定或采取行动时，就有可能产生意想不到的影响判断的偏见。在本演讲中，演讲者将讨论几个重要问题，包括：组织是否系统地追踪测评师的决定，以发现并减少评鉴中的意外偏见？他们应该如何检视偏见和多久检视一次？不同测评师培训方法和偏见之间的关系是什么？测评师培训时间长短和偏见之间有何关系？专业测评师是否或多或少容易产生偏见？偏见是随经验而增加还是减少？测评师的偏见是否随经验而增加？测评师在多个评鉴中心中观察同一个人会产生什么影响？如果发现偏见，组织可以采取哪些行动？</p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/anna.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>14:30 - 15:10</b></p>
                            <p><b>演讲主题：</b>领导力能力建模</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=19">Anna Baczynska 博士， 波兰考明斯基大学助理教授</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>对各类企业均十分实用的领导力能力新观点。
                              <br><b>· </b>可用于发展希望成为领导者的管理者的能力模型。
                              <br><b>· </b>管理者和领导者在能力领域的差异。
                              </p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/Martin_Kleinmann.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>15:20 - 16:00</b></p>
                            <p><b>演讲主题：</b> 评鉴中心：概念型回顾</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=26">Martin Kleinmann 博士， 瑞士苏黎世大学心理学系教授</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>评鉴中心研究中的概念模型和实证研究概述。
                              <br><b>· </b>开展评鉴中心的实际意义。
                              <br><b>· </b>未来的研究指南。
                              </p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/czl.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>16:10 - 16:50</b></p>
                            <p><b>演讲主题：</b>评鉴中心运营的准则和道德考量——中国大陆及台湾地区适用的中文版本，以及组织如何从准则中获益</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=58">陈子良 博士， 谊威管理咨询总裁兼首席顾问</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>描述中国成立专家委员会编制第一版AC中文版指南的过程。
                              <br><b>· </b>描述中文版AC指南和国际版本的差异，此差异如何反应文化内涵，以及指出未来的趋势。
                              <br><b>· </b>说明中文版指南对于企业实务界的专业人士的价值, 以及如何使用此指南来建构更有效的评鉴中心与发展中心。
                              </p>
                            </span>
                          </div>
                        </li>
                      </ul>
                      <h3>分会场C</h3>
                      <ul>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/zhj.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>13:30 - 13:40</b></p>
                            <p><b>开场嘉宾及主持人</b></p>
                            <p>郑皓觉，DDI高级顾问</p>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/lyt.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>13:40 - 14:20</b></p>
                            <p><b>演讲主题：</b>基于领导力模型与评鉴中心的高管人员公开竞聘——某央企投资上市公司K集团的成功实践</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=68">李运亭， 才标企业管理咨询合伙人</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>央企背景上市公司K集团高层管理职位领导力模型体系构建。
                              <br><b>· </b>基于领导力模型的AC工具开发，选拔流程设计。 
                              <br><b>· </b>基于AC的高管职位公开竞聘项目实施和效果反馈。
                              </p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/llx.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>14:30 - 15:10</b></p>
                            <p><b>演讲主题：</b>打造具备行业特色的人才招募测评体系</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=40">刘俪璇， 三星财产保险（中国）有限公司人力资源总监</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>人才供应链地图剖析。
                              <br><b>· </b>冰山模型下的任职资格3D模型。
                              <br><b>· </b>如何有效评估人才招募的四维导向测评体系：能力导向的胜任力评估，性格导向的融合度评估，文化导向的适应性评估，特性导向的发展性评估。
                              </p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/Young.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>15:20 - 16:00</b></p>
                            <p><b>演讲主题：</b>韩国13年评鉴中心的运营回顾</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=88">Young-Jae Kim， 韩国Assesta高级研究分析师</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>2006年，韩国政府启动运作评鉴中心（AC），以选拔、晋升中层官员担任更高层级的职务。从那时起，评鉴中心就从中央政府扩展到了公营企业，成为选拔和晋升人才的先进工具。在本演讲中，演讲者将介绍韩国政府中评鉴中心的进程和发展，并分别从 和微观视角探讨评鉴中心的管理和运营。</p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/lcy.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>16:10 - 16:50</b></p>
                            <p><b>演讲主题：</b>管理才能评鉴中心的应用与发展</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=23">林灿萤， 中国文化大学管理才能评鉴暨发展中心指导顾问</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>业务模拟培训计划可以与评鉴中心相结合，对高管进行考核。
                              <br><b>· </b>商业模拟培训计划中的行为观察在对高管能力进行分类上具有很高的效度和效能。
                              <br><b>· </b>在高管评鉴设计及应用中采用业务模拟培训项目的原因。
                              </p>
                            </span>
                          </div>
                        </li>
                      </ul>
                      <h3>分会场D</h3>
                      <ul>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/ydy.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>13:30 - 13:40</b></p>
                            <p><b>开场嘉宾及主持人：</b></p>
                            <p>姚德瑜， DDI华南区董事总经理</p>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/syh.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>13:40 - 14:20</b></p>
                            <p><b>演讲主题：</b>如何判断一个人是否具有领导者的潜力？</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=82">苏永华 博士， 诺姆四达集团董事长兼总裁</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>传统的领导人才选拔往往依据一些外在的标准，比如学历水平、所学专业、工作经历、过往工作业绩、技能证书等，已难以满足当前快速变化发展环境需求。如何快速、准确判断一个人是否具有领导者的潜力，对于企业的人才管理，特别是管理人才队伍的建设来说至关重要。诺姆四达根据多年的领导人才选拔与培养发展研究和实践经验，提出了一套领导者潜力评价与选拔的理论体系和工具方法系统。
                              <br><b>· </b>区分领导力与领导潜力的意义
                              <br><b>· </b>领导潜力APM理论与实践价值
                              <br><b>· </b>如何提高领导潜力鉴别的精准度？
                              </p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/sx.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>14:30 - 15:10</b></p>
                            <p><b>演讲主题：</b>人才评鉴助力欧姆龙构筑人才防线</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=44">苏遐， 欧姆龙（中国）有限公司上海分公司人力资源中心长</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>本演讲将以评鉴中心在欧姆龙中国从缘起到实施，从初见成效到持续升级的秘籍。</p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/rxq.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>15:20 - 16:00</b></p>
                            <p><b>演讲主题：</b>数字化时代高潜质人才的测评和发展</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=80">饶晓谦， 励衿咨询管理合伙人、联合创始人</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>数字化时代，传统的人才衡量和发展方式受到了极大的挑战。人才的测评和发展都向着动态的、面向敏捷性的方向迅速转移。如何在这样一个时代定义和衡量人才的潜力？本演讲将探讨在数字化时代我们需要什么样的人才，以及数字化高潜人才的测评与发展。</p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/zxx.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>16:10 - 16:50</b></p>
                            <p><b>演讲主题：</b>人才发展的转型</p>
                            <p><b>演讲嘉宾：</b>赵隽艳， 百特医疗大中华区人力资源高级总监及亚太区人才管理高级总监</p>
                           <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>VUCA时代，商业环境发生巨变，新技术、看不见的对手不断涌现，各行各业都在转型、创新与突破。越来越多的组织正尝试着让公司的业务单元尽可能变得敏捷。百特医疗在过去3年中经历了重大的组织变革和文化变革，致力于打造一个更加高绩效敏捷的组织。</p>
                           </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/xt.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>17:00 - 17:40</b></p>
                            <p><b>演讲主题：</b>AI如何助力人才评鉴开创新视角新功能</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=101">肖婷， 猎聘人才与组织发展研究院院长</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>伴随人工智能技术的日益兴起，人才测评也迎来了新的机遇。有了机器捕捉的大量信息，再结合人类专家的经验，AI可以很快学习，并形成模型输出。AI赋能的人才测评可以获取比人类更多的信息，并借人类的经验完成比更加精准的人才分析、辨别。
                              <br><b>· </b>AI带来的机遇。
                              <br><b>· </b>AI实现的路径。
                              <br><b>· </b>AI人才评鉴实践。
                              </p>
                            </span>
                          </div>
                        </li>
                      </ul>
                      <h3>分会场E</h3>
                      <ul>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/Billy.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>13:30 - 13:40</b></p>
                            <p><b>开场嘉宾及主持人：</b></p>
                            <p>孙逸彬， DDI大中华区测评高级产品经理</p>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/mjh.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>13:40 - 14:20</b></p>
                            <p><b>演讲主题：</b>高端人才引进中的评价与发展</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=12">马剑虹 博士， 浙江大学心理与行为科学系教授</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>高端人才引进过程中的个性与适应的问题。
                              <br><b>· </b>高端人才引进中会出现不同的组织适应的结果：一体化（integration）、组合化（combination）、分离化（separation）和边缘化（marginalization）。一体化是最大化发挥人才的状态。
                              <br><b>· </b>评价中心的评价+发展功能能够实现人才选拔和适应的有效统一。
                              </p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/elise.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>14:30 - 15:10</b></p>
                            <p><b>演讲主题：</b>如何将神经科学应用于领导力评鉴与发展？</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=90">朱丽艳， 脑优势领导力中心创始人、组织心理学家</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>神经科学目前在人才评鉴领域的应用，及对于未来的猜想
                              <br><b>· </b>如何运用神经科学减少在评鉴或招聘中的无意识偏见，提升评鉴或招聘决策的有效性？
                              <br><b>· </b>神经科学如何帮助发展更好的领导者？
                              </p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/pj.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>15:20 - 16:00</b></p>
                            <p><b>演讲主题：</b>从沙漠到绿洲——人才评鉴和人才发展的现实应用</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=42">平静， 喜利得中国、喜利得北亚区能源与工业行业人力资源总监</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>喜利得在过去几年着力于打造健康的人才梯队，在人才发展方面有很多的思路和实践，也通过努力将高潜力人才的比例从12%提高到25%，成功满足了公司发展在人才发展方面的需求。该演讲将分享喜利得的具体战略和做法，以及人才评鉴在人才发展项目中的具体应用。
                              <br><b>· </b>分享喜利得如何打造支持企业发展的人才战略。
                              <br><b>· </b>分享喜利得的四个高潜力人才标准，以及评鉴方法。
                              <br><b>· </b>介绍喜利得的高潜力人才发展项目以及实际效果。
                              </p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/xxj.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>16:10 - 16:50</b></p>
                            <p><b>演讲主题：</b>海外派遣经理跨文化胜任素质模型：基于中资跨国公司的质性研究</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=28">徐笑君 博士， 复旦大学管理学院副教授</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>随着一带一路的推进，更多的中资企业走向世界，更多的外派经理活跃在国际商务舞台。国际经理人能否适应跨文化工作环境，顺利完成海外派遣任务，直接决定着中资企业海外战略的成败。
                              <br><b>· </b>介绍外派经理跨文化胜任素质模型，包括各胜任素质的界定和行为表现。
                              <br><b>· </b>揭示跨文化胜任素质各构成要素之间的相互影响关系。
                              <br><b>· </b>分析动机性个体特质（内驱力）如何与激励措施（外驱力）互为补充，共同影响外派经理的行为。
                              </p>
                            </span>
                          </div>
                        </li>
                      </ul>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="11月15日" name="fourth">
                    <div class="media">
                      <h2>11月15日上午</h2>
                      <h3>主会场演讲</h3>
                      <ul>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/hjh.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>09:00 - 09:40</b></p>
                            <p><b>演讲主题：</b>培养未来的领导人</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=8">何京华， 腾讯学院副院长</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>2004年，腾讯上市，业务高速发展，对人才的诉求也越来越大，尤其是在后备接班人培养方面投入了大量资源，飞龙项目应运而生。早期的“飞龙”更关注管理者的培养，2009年起腾讯希望对管理者有更精准的培养方式，测评工作的开展也提到日程上来。本演讲将分享这一测评项目中对评鉴中心的全面性思考和回顾，总结腾讯踩过的坑，也展示腾讯的成果，对选拔和培养领导者起到借鉴作用。</p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/zwg.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>09:40 - 10:20</b></p>
                            <p><b>演讲主题：</b>高效识别自我颠覆型领导人，赢在数字化时代</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=89">张伟钢， 光辉国际全球高级合伙人，咨询业务中国区董事总经理</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p>数字化时代下，传统领导力将面临淘汰，组织迫切需要可以面向未来的新型领导力。而领导者只有不断颠覆自我，才能面对不断被颠覆的市场环境。简而言之，组织而今迫切需要的就是自我颠覆型领导者。基于光辉国际特有的潜力测评工具，我们发现管理不确定性以及变革敏锐度是发现自我颠覆领导者的关键指标。该演讲将探讨企业如何定义、甄选、测评识别具备潜力的自我颠覆型领导人，助力企业赢在数字化时代。</p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/dwb.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>10:20 – 11:00</b></p>
                            <p><b>演讲主题：</b>我们的成长之路</p>
                            <p><b>演讲嘉宾：</b><a href="https://assessmentcenters.hrflag.com/brief?detail=9">丁伟波， 费森尤斯卡比中国区总裁</a></p>
                            <span class="flexspan">
                              <p><b>演讲介绍：</b></p>
                              <p><b>· </b>费森尤斯卡比的人才战略。
                              <br><b>· </b>费森尤斯卡比的领导团队。
                              <br><b>· </b>公司在人才发展和组织竞争力建设的实践。
                              </p>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div class="media-object">
                            <div>
                              <img src="http://static.hrflag.com/img/speakers/ddi/BruceWatt.png" alt="">
                            </div>
                          </div>
                          <div class="media-body">
                            <p><b>11:00 – 11:50</b></p>
                            <p><b>演讲主题：</b>全球商业变局中的高端人才战略与布局</p>
                            <p><b>演讲嘉宾：</b>布鲁斯·华特 博士， DDI全球副总裁</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <wrapleft></wrapleft>
        </div>
    </div>
    <foots></foots>
  </div>   
</template>

<script>
  // import '../assets/js/data.js'
  import home from '@/components/commn/home'
  import foots from '@/components/commn/foots'
  import wrapleft from '@/components/commn/wrapleft'
  export default {
      components:{
        home,
        foots,
        wrapleft
      },
      metaInfo: {
        title: '大会日程-第42届全球人才评鉴高峰会暨领导人才发展论坛',
        meta: [
          {
            name: 'keywords',
            content: '第42届全球人才评鉴高峰会，领导人才发展论坛'
          },
          {
            name: 'description',
            content: '第42届全球人才评鉴高峰会暨领导人才发展论坛活动时间及地点：11 月13~15日 ， 上海雅居乐万豪酒店。'
          }
        ]
      },
      data() {
        return {
          activeName: 'second',
          info:'',
          KeynoteSpeakers:[],
            BusinessLeaders:[],
            CrossBorderExperts:[],
            LeadingProfessionals:[],
            TopScholarsdatas:[],
        }
      },
      methods: {
        handleClick(tab, event) {
          // console.log(tab, event);
        },
        toBio(item,id) {
            this.$router.push({ 
                path: '/brief', 
                query:{ KeynoteSpeakers:item.name}})//跳转个人简介
                localStorage.detailsList = JSON.stringify(item)
        },
        toBio1(item,id) {
            this.$router.push({ 
                path: '/brief', 
                query: { BusinessLeader: item.name }})//跳转个人简介
            localStorage.detailsList = JSON.stringify(item)
        },
        toBio2(item,id) {
            this.$router.push({ 
                path: '/brief', 
                query: { CrossBorderExpert: item.name }})//跳转个人简介
            localStorage.detailsList = JSON.stringify(item)
        },
        toBio3(item,di) {
            this.$router.push({ 
                path: '/brief', 
                query: { LeadingProfessional: item.name }})//跳转个人简介
            localStorage.detailsList = JSON.stringify(item)
        },
        toBio4(item,id) {
            this.$router.push({ 
                path: '/brief', 
                query: { TopScholarsdata: item.name }})//跳转个人简介
            localStorage.detailsList = JSON.stringify(item)
        },
        getBio () {
            this.axios({
                method: "post",
                url: "https://form.hrflag.com/WebAPI/HRflag/GetBioInCN?iAre=0",
            })
            .then(res=> {
                console.log(res)
                this.KeynoteSpeakers = res.data
            })
            .catch(function(error) {
                console.log(error)
            })
        },
        getBio1 () {
            this.axios({
                method: "post",
                url: " https://form.hrflag.com/WebAPI/HRflag/GetBioInCN?iAre=3"
            })
            .then(res=> {
                this.BusinessLeaders = res.data
            })
            .catch(function(error) {
                console.log(error)
            })
        },
        getBio2 () {
            this.axios({
                method: "post",
                url: " https://form.hrflag.com/WebAPI/HRflag/GetBioInCN?iAre=4"
            })
            .then(res=> {
                this.CrossBorderExperts = res.data
            })
            .catch(function(error) {
                console.log(error)
            })
        },
        getBio3 () {
            this.axios({
                method: "post",
                url: " https://form.hrflag.com/WebAPI/HRflag/GetBioInCN?iAre=2"
            })
            .then(res=> {
                this.LeadingProfessionals = res.data
            })
            .catch(function(error) {
                console.log(error)
            })
        },
        getBio4 () {
            this.axios({
                method: "post",
                url: " https://form.hrflag.com/WebAPI/HRflag/GetBioInCN?iAre=1"
            })
            .then(res=> {
                this.TopScholarsdatas = res.data
            })
            .catch(function(error) {
                console.log(error)
            })
        },
      },
      created() {
          this.getBio ()
          this.getBio1 ()
          this.getBio2 ()
          this.getBio3 ()
          this.getBio4 ()
      }
  }
</script>
<style scoped>
    @import url('../assets/css/inpublic.css');
    table th, table td {
        font-size: 16px;
    }
    .el-table .warning-row {
        background: oldlace;
    }
    .el-table .success-row {
        background: #f0f9eb;
    }
    .el-table--border {
        border: solid 10px #f0f0f0 !important;
    }
    .el-tabs__nav {
      width: 100%;
    }
    .el-tabs__nav .el-tabs__item {
      width: 25%;
      text-align: center;
      padding: 0;
    }
    .el-tabs__active-bar {
      background-color: #e4912b;
      width: 25% !important;
    }
    .el-tabs__item:hover {
      color: #e4912b !important;
      cursor: pointer;
  }
  .el-tabs__item.is-active {
      color: #e4912b !important;
  }
  .el-tabs--top.el-tabs--card .el-tabs__item:nth-child(2) {
      padding: 0 !important;
  }
  .el-tabs--top.el-tabs--card .el-tabs__item:last-child {
    padding: 0 !important;
  }
  .el-tabs__item {
    font-size: 18px;
  }
  .el-tabs--card>.el-tabs__header .el-tabs__nav {
    background: #f0f0f0;
  }
  .el-tabs--top.el-tabs--card .el-tabs__item:nth-child(2) {
    padding: 0 !important;
  }
  @media screen and (max-width:768px) {
    .el-tabs__item {
        font-size: 12px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/agenda.vue